import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var RecycleBinSvg = function RecycleBinSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.59 10.389v7.441h1.365V10.39zM14.046 17.83V10.39h1.363v7.441z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.736 5.97a4.46 4.46 0 0 1 1.21-2.427A4.27 4.27 0 0 1 12 2.25c1.145 0 2.244.466 3.053 1.294a4.46 4.46 0 0 1 1.211 2.427H22v1.395h-2.046V22.25H4.045V7.365H2V5.97zm2.175-1.44A2.92 2.92 0 0 1 12 3.644c.784 0 1.535.319 2.09.886.39.4.66.9.785 1.44h-5.75c.126-.54.395-1.04.786-1.44M5.409 20.854V7.365h13.182v13.489z",
    clipRule: "evenodd"
  }));
};
export var RecycleBin = function RecycleBin(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: RecycleBinSvg
  }));
};